import React from "react";
import "./App.css";
import Container from "./components/Container/Container";

function App() {
  return <Container />;
}

export default App;
